<template>
  <FullPage>
    <Webview>
      <Header title="頻道設定" :close="back"></Header>
      <div class="block_frame _fill">
        <div class="block_title">通知設定</div>
        <div class="block_ctn">
          <div class="label">通知</div>
          <el-switch v-model="allowNotification" :disabled="!ready" @change="muteChannel"></el-switch>
        </div>
      </div>
      <div class="wv_button">
        <div class="main_btn _plain" @click="submit">退出頻道</div>
      </div>
    </Webview>
    <Watch v-if="channel" :callback="init" />
  </FullPage>
</template>

<script>
//api
import { muteChannel, exitChannel } from "@/api/channel"
export default {
  props: {
    close: Function
  },
  data() {
    return {
      ready: false,
      allowNotification: false
    }
  },
  computed: {
    ...mapGetters(["channels"]),
    channelID() { return this.$route.params.channelID },
    channel() {
      return this.channels.find(data => data.channelID === this.channelID);
    },
  },
  methods: {
    back() {
      this.$router.replace({ path: `/channel/room/${this.channelID}` });
    },
    init() {
      this.ready = true;
      this.allowNotification = !this.channel.muted;
    },
    submit() {
      CONFIRM({
        text: "若您退出頻道，通知訊息及紀錄將會被刪除\n是否要退出？",
        label_submit: "退出頻道",
        close: () => { },
        submit: () => {
          this.exitChannel();
        },
      })
    },
    muteChannel() {
      muteChannel(this.channelID, !this.allowNotification);
    },
    async exitChannel() {
      try {
        await exitChannel(this.channelID);
        await this.$store.dispatch("GetChannels", true);
        this.$router.replace({ path: "/channel" });
      }
      catch (error) {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: "退出頻道" }));
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.block_frame {
  background-color: $gray_95;
}
.wv_button {
  background-color: $gray_95;
}
</style>